'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var _slicedToArray = (function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i['return']) _i['return'](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError('Invalid attempt to destructure non-iterable instance'); } }; })();

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x3, _x4, _x5) { var _again = true; _function: while (_again) { var object = _x3, property = _x4, receiver = _x5; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x3 = parent; _x4 = property; _x5 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

exports.groupFactory = groupFactory;
exports.formId = formId;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

var _utilsClone = require('./utils/clone');

var _utilsClone2 = _interopRequireDefault(_utilsClone);

var _utilsBaseValidator = require('./utils/base-validator');

var _sharedTypeUtils = require('./shared/type-utils');

var _errors = require('./errors');

var groupMixin = function groupMixin() {
  var Base = arguments.length <= 0 || arguments[0] === undefined ? (function () {
    function _class() {
      _classCallCheck(this, _class);
    }

    return _class;
  })() : arguments[0];
  return (function (_Base) {
    _inherits(_class2, _Base);

    function _class2() {
      var obj = arguments.length <= 0 || arguments[0] === undefined ? {} : arguments[0];

      _classCallCheck(this, _class2);

      _get(Object.getPrototypeOf(_class2.prototype), 'constructor', this).call(this, obj);
      this.groupByTree = obj.groupByTree;
      this.invalidArguments = obj.invalidArguments || [];
    }

    _createClass(_class2, [{
      key: 'sum',
      value: function sum(fieldName, projectedField) {
        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate = this._groupValidator('.sum').arityIsAtLeastOne(arguments).typeIsString(fieldName).validateAndAggregate();

        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate2 = _slicedToArray(_groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate, 1);

        var newInvalidArguments = _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate2[0];

        return this._addAccumulator('sum', fieldName, projectedField, newInvalidArguments);
      }
    }, {
      key: 'avg',
      value: function avg(fieldName, projectedField) {
        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate3 = this._groupValidator('.avg').arityIsAtLeastOne(arguments).typeIsString(fieldName).validateAndAggregate();

        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate32 = _slicedToArray(_groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate3, 1);

        var newInvalidArguments = _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate32[0];

        return this._addAccumulator('avg', fieldName, projectedField, newInvalidArguments);
      }
    }, {
      key: 'min',
      value: function min(fieldName, projectedField) {
        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate4 = this._groupValidator('.min').arityIsAtLeastOne(arguments).typeIsString(fieldName).validateAndAggregate();

        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate42 = _slicedToArray(_groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate4, 1);

        var newInvalidArguments = _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate42[0];

        return this._addAccumulator('min', fieldName, projectedField, newInvalidArguments);
      }
    }, {
      key: 'max',
      value: function max(fieldName, projectedField) {
        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate5 = this._groupValidator('.max').arityIsAtLeastOne(arguments).typeIsString(fieldName).validateAndAggregate();

        var _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate52 = _slicedToArray(_groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate5, 1);

        var newInvalidArguments = _groupValidator$arityIsAtLeastOne$typeIsString$validateAndAggregate52[0];

        return this._addAccumulator('max', fieldName, projectedField, newInvalidArguments);
      }
    }, {
      key: 'count',
      value: function count() {
        var _groupValidator$arityIsZero$validateAndAggregate = this._groupValidator('.count').arityIsZero(arguments).validateAndAggregate();

        var _groupValidator$arityIsZero$validateAndAggregate2 = _slicedToArray(_groupValidator$arityIsZero$validateAndAggregate, 1);

        var newInvalidArguments = _groupValidator$arityIsZero$validateAndAggregate2[0];

        var groupByTree = (0, _utilsClone2['default'])(this.groupByTree);
        var accFieldName = 'count';
        var accumulator = { '$sum': 1 };
        groupByTree[accFieldName] = accumulator;
        return this._copy(groupByTree, newInvalidArguments);
      }
    }, {
      key: '_addAccumulator',
      value: function _addAccumulator(acc, fieldName, projectedField, newInvalidArguments) {
        var groupByTree = (0, _utilsClone2['default'])(this.groupByTree) || { _id: formId() };
        var accFieldName = projectedField || fieldName + capitalize(acc);
        var accumulator = {};
        accumulator['$' + acc] = '$' + fieldName;
        groupByTree[accFieldName] = accumulator;
        return this._copy(groupByTree, newInvalidArguments);
      }
    }, {
      key: '_copy',
      value: function _copy(groupByTree, invalidArguments) {
        return new this.constructor(Object.assign({}, this, { groupByTree: groupByTree, invalidArguments: invalidArguments }));
      }
    }, {
      key: '_groupValidator',
      value: function _groupValidator(operatorName) {
        return new GroupValidator(operatorName, this.invalidArguments);
      }
    }]);

    return _class2;
  })(Base);
};

exports.groupMixin = groupMixin;

var WixDataGroupBuilder = (function (_groupMixin) {
  _inherits(WixDataGroupBuilder, _groupMixin);

  function WixDataGroupBuilder() {
    _classCallCheck(this, WixDataGroupBuilder);

    _get(Object.getPrototypeOf(WixDataGroupBuilder.prototype), 'constructor', this).apply(this, arguments);
  }

  _createClass(WixDataGroupBuilder, [{
    key: '_build',
    value: function _build() {
      throwErrorIfInvalid(this.invalidArguments);
      return this.groupByTree;
    }
  }]);

  return WixDataGroupBuilder;
})(groupMixin());

exports.WixDataGroupBuilder = WixDataGroupBuilder;

function throwErrorIfInvalid(invalidArguments) {
  if (invalidArguments.length > 0) {
    throw (0, _errors.validationError)(_errors.messages.groupBuilderInvalid(invalidArguments));
  }
}

var GroupValidator = (function (_AggregatingValidator) {
  _inherits(GroupValidator, _AggregatingValidator);

  function GroupValidator(operatorName, previousInvalidArguments) {
    _classCallCheck(this, GroupValidator);

    _get(Object.getPrototypeOf(GroupValidator.prototype), 'constructor', this).call(this, previousInvalidArguments);
    this.operatorName = operatorName;
  }

  _createClass(GroupValidator, [{
    key: 'typeIsString',
    value: function typeIsString(value) {
      var _this = this;

      return this.addValidation(function () {
        return (0, _sharedTypeUtils.isString)(value);
      }, function () {
        return _errors.messages.filterValidations.typeIsString(_this.operatorName, value);
      });
    }
  }]);

  return GroupValidator;
})(_utilsBaseValidator.AggregatingValidator);

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function groupFactory() {
  var idField = formId.apply(undefined, arguments);
  return groupWithId(idField);
}

function formId() {
  for (var _len = arguments.length, fieldName = Array(_len), _key = 0; _key < _len; _key++) {
    fieldName[_key] = arguments[_key];
  }

  if (fieldName.length === 1) {
    return '$' + fieldName;
  } else if (fieldName.length > 1) {
    var _ret = (function () {
      var _id = {};
      fieldName.forEach(function (field) {
        return _id[field] = '$' + field;
      });
      return {
        v: _id
      };
    })();

    if (typeof _ret === 'object') return _ret.v;
  } else {
    return '0';
  }
}

function groupWithId(_id) {
  return new WixDataGroupBuilder({ groupByTree: { _id: _id } });
}